import InputForm from '../../atoms/InputForm/InputForm'

const InputGroup = ({label, type, name, id, classe, placeholder}) =>{
    return(
        <>
            <label htmlFor={id}>
                {label}
            </label>
            <InputForm type={type} name={name} id={id} classe={classe} placeholder={placeholder}/>
        </>
    )

}

export default InputGroup